import { Anchor, Text } from '@zillow/constellation-10';

type Props = {
  text: string;
  href: string;
  cta: string;
};
const TextLinkContent = ({ text, href, cta }: Props) => (
  <Text>
    {text}
    <Anchor target="_blank" href={href}>
      {cta}
    </Anchor>
  </Text>
);

export default TextLinkContent;
